module.exports = { id: "middlemotor", url: "/build/app/img/symbols.svg#middlemotor", viewBox: "", toString: function() { return this.url; } };